import React from "react"
import { graphql } from "gatsby"

import Description from "components/description"
import Resource from "./resource"

type ResourceGroupProps = Omit<Queries.ResourceGroupFragment, "contentful_id">

export default function ResourceGroup(props: ResourceGroupProps) {
  const { title, description, resources } = props

  return (
    <div>
      <h2 className="border-b border-secondary pb-2">{title}</h2>

      {description && (
        <div className="mb-8">
          <Description description={description} />
        </div>
      )}

      <div className="space-y-12 md:space-y-16">
        {resources.map(resource => (
          <Resource {...resource} key={resource.contentful_id} />
        ))}
      </div>
    </div>
  )
}

export const fragment = graphql`
  fragment ResourceGroup on ContentfulResourceGroup {
    contentful_id
    title
    description {
      raw
    }
    resources {
      ...Resource
    }
  }
`
